
export const SOURCE_FETCH      = 'SOURCE_FETCH'; 
export const SOURCE_UPDATE     = 'SOURCE_UPDATE'; 
export const SOURCE_SAVE       = 'SOURCE_SAVE';  //save the source to db ,price,drawing
export const SOURCE_ERR_MSG    = 'SOURCE_ERR_MSG';
export const SOURCE_REMOVE_ERR = 'SOURCE_REMOVE_ERR';
// export const PRODUCT_SOURCE    = 'PRODUCT_SOURCE';
